import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NFTStorage, File } from 'nft.storage';
import { collection, addDoc } from 'firebase/firestore';

import { db } from '../firebase';
const client = new NFTStorage({ token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweGU5YmUxN0NGN2NEM0U0MDliMDlkMDYyQmZkNWVmRDczQjUyNWM3NkUiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY1MzQyMjkwMzA4MCwibmFtZSI6InNwYXRpYWxvcmFjbGVzIn0.c60OCTW-im7G_ZUvPJdsMo8XMkpMCzz_D1_MoVy2Ifk" });

function ImageForm() {
    const imageCollectionRef = collection(db, "images");

    const navigate = useNavigate();

    const [name, setName] = useState('');
    const [location, setLocation] = useState('');
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState('');
    const [url, seturl] = useState('');

    const getImage = event => {
      const file = event.target.files[0]
      console.log(file)
      setImage(file)
    }

    const submitTask = async () => {
      try {
        setLoading(true);

        const res = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${location}.json?proximity=ip&types=place&access_token=pk.eyJ1Ijoic3BhdGlhbG9yYWNsZXMiLCJhIjoiY2wzbmh0YXpwMDAwYzNpbnoxcmsyOWdlZSJ9.9ee8oy8abpOPlQ7JUo7ccA`);
        const geodata = await res.json();
        console.log(geodata);
        console.log(geodata.features[0].center);
        const geocode = geodata.features[0].center.toString();
       
        const imageFile = new File([ image ], image.name, { type: image.type });
        const metadata = await client.store({
            name: name,
            description: geocode,
            image: imageFile
        });

        console.log(metadata);
        seturl(metadata.url);

        let imageCid = metadata.url.slice(7);
        imageCid = imageCid.split("/");
        let data = await fetch(`https://${imageCid[0]}.ipfs.nftstorage.link/${imageCid[1]}`);
        data = await data.json();
        let arr = data.image.slice(7);
        arr = arr.split("/");
        data.url = `https://${arr[0]}.ipfs.nftstorage.link/${arr[1]}`;

        await addDoc(imageCollectionRef, {
          name: name,
          location: geodata.features[0].center,
          cid: metadata.url,
          url: data.url
        });
        setLoading(false);
        navigate('/map');
      } catch(error) {
        console.error(error);
        setLoading(false);
      }
    }

    return (
      <div className="container">
        <div className="card card-body m-auto mt-4" style={{ maxWidth: "600px"}}>
          <h2>Add 360 Image to Map</h2>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">Name</label>
            <input className="form-control" id="name" onChange={(e) => setName(e.target.value)}/>
          </div>
          <div className="mb-3">
            <label htmlFor="location" className="form-label">Location</label>
            <input className="form-control" id="location" onChange={(e) => setLocation(e.target.value)}/>
          </div>
          <div className="mb-3">
            <label htmlFor="formFileMultiple" className="form-label">
              Add Image
            </label>
            <input className="form-control" type="file" id="formFileMultiple" onChange={getImage} />
          </div>
          {!loading
            ? <button className="btn btn-primary mb-3"onClick={submitTask} >
              Submit
            </button>
            : <p>Loading...</p>
          }
          <p>{url}</p>
      </div>
    </div>
  )
}

export default ImageForm;